import React, { useEffect } from "react";
import LogoLayout from "../../../components/logolayout/logolayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import TextInput from "../../../components/form/inputs/text-input/text-input";
import DateTimeInput from "../../../components/form/inputs/datetime-input/date-time-input";
import {
  formatPhone,
  phonereg,
  setNativeValue,
  showToast,
} from "../../../utils/utils";
import PlacesInput from "../../../components/form/inputs/places-input/places-inputs";
import axiosInstance from "../../../config/axios";

export default function RegisterProfilPage() {
  const location = useLocation();
  const params = location.state;
  const redirect = window.history.state.idx == 0;
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const values = {
        last_name: sessionStorage.getItem("last_name"),
        first_name: sessionStorage.getItem("first_name"),
        phone: sessionStorage.getItem("phone"),
        birth_date: sessionStorage.getItem("birth_date"),
        address: sessionStorage.getItem("address"),
      };
      if (
        values.phone &&
        values.birth_date &&
        values.address &&
        values.last_name &&
        values.first_name
      ) {
        //query selector to fill the inputs
        const phone = document.getElementById("phone") as HTMLInputElement;
        const address = document.querySelector(
          "input .locinp"
        ) as HTMLInputElement;
        const birth_date = document.getElementById(":r1:") as HTMLInputElement;
        const last_name = document.getElementById(
          "last_name"
        ) as HTMLInputElement;
        const first_name = document.getElementById(
          "first_name"
        ) as HTMLInputElement;
        try {
          setNativeValue(phone, values.phone);

          setNativeValue(last_name, values.last_name);
          setNativeValue(first_name, values.first_name);
          setNativeValue(birth_date, values.birth_date);
          setNativeValue(address, values.address);
        } catch (error) {}
      }
    }, 100);
  }, []);

  if (redirect) return <Navigate to={"/register"} replace />;
  async function onSubmit(form: any) {
    const { job, siret, role, fromMobileApp } = params;
    form = { job, siret, role, fromMobileApp, ...form };
    sessionStorage.setItem("last_name", form.last_name);
    sessionStorage.setItem("first_name", form.first_name);
    sessionStorage.setItem("phone", form.phone);
    sessionStorage.setItem("birth_date", form.birth_date);
    sessionStorage.setItem("address", form.address);

    try {
      const { data } = await axiosInstance.post(
        "users/register/complete",
        form
      );
      //navigate("/register/success", { state: { form, plans: data.plans, fromMobileApp } });

      (window as any)?.ReactNativeWebView?.postMessage("close");
      navigate("/register/subscription", {
        state: { form, plans: data.plans },
      });
    } catch (e) {
      showToast("Une erreur est survenue");
    }
  }

  const today = new Date();
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );
  return (
    <LogoLayout params={params} onSubmit={onSubmit} progress={50}>
      <h1>Inscription</h1>
      <p className="subtitle">{params.role}</p>
      <h2 className="title">Mon profil</h2>
      <div>
        <TextInput
          name="last_name"
          required="Nom invalide"
          placeHolder="Nom"
          label="Nom"
        />
        <TextInput
          name="first_name"
          required="Prénom invalide"
          placeHolder="Prénom"
          label="Prénom"
        />
        <DateTimeInput
          max={eighteenYearsAgo}
          name="birth_date"
          required="Date de naissance invalide"
          label="Date de naissance"
        />
        <TextInput
          validate={(val: any) =>
            !phonereg.test(val?.replace(/\D/g, ""))
              ? "Téléphone invalide"
              : true
          }
          name="phone"
          format={formatPhone}
          maxLength={14}
          placeHolder="Téléphone"
          label="Téléphone"
        />
        <PlacesInput
          name="address"
          required={true}
          placeHolder="Adresse"
          label="Adresse, Code postal, Ville"
        />
      </div>
    </LogoLayout>
  );
}
